import { Point } from "../models/Point";
import { EncodingUtils } from "../utils/EncodingUtils";
import { SvgUtils } from "../utils/SvgUtils";
import { VisualizerBase } from "./VisualizerBase";

export class ZkSync extends VisualizerBase {
    constructor(_placeholderMode: boolean = false) {
        super("zksync", _placeholderMode);
    }

    public override generate(hex: string, coreMode: boolean = false): SVGSVGElement {
        const svg = this.createSvg();
        this.hexArray = EncodingUtils.hexStringToHexArray(hex);

        const size = 320;
        const center = size / 2;
        const height = 70;
        const triangleLength = height;
        const htl = triangleLength / 2;
        const x00 = height * Math.tan(25 * Math.PI / 180);
        const sr3 = Math.sqrt(3);
        const sr3HTL = sr3 * x00;
        const htl2 = x00 + 10;

        const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");

        if(!coreMode) {
            const idOB = `circleOutbounding_${this.chainIdName}`;
            const dOB = SvgUtils.getDOfPathOfCircle(0, 0, 150);
            const obCircle = document.createElementNS("http://www.w3.org/2000/svg", "path");
            obCircle.id = idOB;
            obCircle.setAttribute("d", `${dOB}`);
            defs.appendChild(obCircle);
        }

        const points: Array<Point> = [ new Point(0, 70),
            new Point(x00, 0),
            new Point(0, -70),
            new Point(-x00, 0)
        ];
        const polygonId = `polygon_50deg_70_${this.chainIdName}`;
        const polygon = SvgUtils.createPolygonPath(polygonId, points, true, ``, "", 0);
        defs.appendChild(polygon);

        const x4 = htl * Math.tan(20 * Math.PI / 180);
        const pointsSign: Array<Point> = [ new Point(0, htl),
            new Point(x00, 0),
            new Point(0, -htl),
            new Point(x4, 0)
        ];
        const polygonIdSign = `polygon_sign_${this.chainIdName}`;
        const polygonSign = SvgUtils.createPolygonPath(polygonIdSign, pointsSign, true, ``, "", 0);
        defs.appendChild(polygonSign);

        svg.appendChild(defs);
        
        if(!coreMode) {
            // outbound: moving 3 circles
            this.appendMovingCirclesOutbound(svg, 150);
            // outbound: scaling circle
            this.appendDynamicScalingOutbound(svg, 1.4);
        }

        const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
        // 0: rotate
        const angle = this.placeholderMode ? 0 : parseInt(this.hexArray[0], 16);

        // polygon-1
        this.addUsePartToGroup(group, polygonId, `translate(0 -80)`, this.getColorHex(1, 2, 3), "", 0);
        // polygon-2
        this.addUsePartToGroup(group, polygonId, `translate(${htl2} 0)`, this.getColorHex(4, 5, 6), "", 0);
        // polygon-3
        this.addUsePartToGroup(group, polygonId, `translate(0 80)`, this.getColorHex(7, 8, 9), "", 0);
        // polygon-4
        this.addUsePartToGroup(group, polygonId, `translate(-${htl2} 0)`, this.getColorHex(10, 11, 12), "", 0);

        // sign-left
        const tmpX = htl2 + x00;
        // const polygon5 = document.createElementNS("http://www.w3.org/2000/svg", "use");
        // polygon5.setAttribute("href", `#${polygonIdSign}`);
        // polygon5.setAttribute("fill", this.getColorHex(13, 14, 15));
        // polygon5.setAttribute("transform", `translate(-${tmpX} 0) scale (-1, 1)`);
        // group.appendChild(polygon5);
        this.addUsePartToGroup(group, polygonIdSign, `translate(-${tmpX} 0) scale (-1, 1)`, this.getColorHex(13, 14, 15), "", 0);
        // sign-right
        // const polygon6 = document.createElementNS("http://www.w3.org/2000/svg", "use");
        // polygon6.setAttribute("href", `#${polygonIdSign}`);
        // polygon6.setAttribute("fill", this.getColorHex(16, 17, 18));
        // polygon6.setAttribute("transform", `translate(${tmpX} 0)`);
        // group.appendChild(polygon6);
        this.addUsePartToGroup(group, polygonIdSign, `translate(${tmpX} 0)`, this.getColorHex(16, 17, 18), "", 0);
        
        group.setAttribute("transform", `rotate(${angle},${center},${center}) translate(${center} ${center})`);
        svg.appendChild(group);
        return svg;
    }

}